import { useEffect, useLayoutEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import './style.scss'
import registrationApi from 'api/registrationApi'
import toolApi from 'api/toolApi'
import { setAppSpinning } from 'app/appSlice'
import { setSelectedDigitalCertificate } from 'app/toolSlice'
import customProtocolCheck from 'custom-protocol-check'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import ModalChooseSignMethod from 'features/Invoice/screens/GuestSignInvoiceReport/components/ModalChooseSignMethod'
import CustomSelect from 'features/Registration/components/CustomSelect'
import ModalConnectConfig from 'features/System/components/Modals/ModalConnectConfig'
import PrivateBaseLayout from 'general/components/eInvoiceComponents/BaseLayout/PrivateBaseLayout'
import { MAX_WAIT_SIGN_INVOICE } from 'general/constants/AppConstants'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import ToastHelper from 'general/helpers/ToastHelper'
import wsHelperInstance from 'general/helpers/WebSocketHelper'
import Global from 'general/utils/Global'
import Utils, {
  findObjectInArray,
  padNumber,
  viewPopupSettingTool,
} from 'general/utils/Utils'
import { useRef } from 'react'
import DatePicker from 'react-datepicker'
import { useDispatch, useSelector } from 'react-redux'
import ModalSignatureInfo from './components/SignatureInfoModal'
import { useQuery } from '@tanstack/react-query'
import axiosClient from 'api/axiosClient'
import { InfoCircleOutlined } from '@ant-design/icons'
import { App, Empty, Input, Radio, Tooltip } from 'antd'
import ModalConfirm from 'general/components/Modal/ModalConfirm'
import ModalWarning from 'general/components/Modal/ModalWarning'
import AppData from 'general/constants/AppData'
import { SelectCustom } from 'features/TaxDeductionDocuments/styled'
import { useTranslation } from 'react-i18next'
import {
  thunkGetCompanyProfile,
  thunkGetTaxAuthority2025,
} from 'features/System/systemSlice'
dayjs.locale('en')

const cerTypeOptions = [
  { label: 'Thêm mới', value: 1 },
  { label: 'Gia hạn', value: 2 },
  { label: 'Ngừng sử dụng', value: 3 },
]

const registrationType = [
  {
    id: 'registration-new',
    value: 1,
    label: 'Đăng ký mới',
  },
  {
    id: 'registration-change',
    value: 2,
    label: 'Thay đổi thông tin',
  },
  // {
  //   id: 'registration-change-of-other-system',
  //   value: 3,
  //   label: 'Cập nhật thông tin tờ khai từ hệ thống khác',
  // },
]

const MAX_WAIT_SIGN_REGISTRATION = 30000

var initialRegistration = {
  type: 1,
  no: 'ĐKTĐ00001',
  // date: '2023-05-31 16:24:18',
  // companyName: 'CÔNG TY CỔ PHẦN ĐẦU TƯ INDO',
  // companyTaxCode: '0312303803-999',
  // taxAuthorityName: 'Chi Cục thuế Quận Tây Hồ',
  // companyContactPerson: 'Nguyễn Thị Thoan',
  // companyAddress: 'Số 32/337, Phố Cầu Giấy, Phường Dịch Vọng, Quận Cầu Giấy, Thành Phố Hà Nội',
  // companyEmail: 'ketoanicorp@gmail.com',
  // companyPhoneNumber: '0989102859',

  // companyCount: 1,

  // locationName: 'Hà Nội',
  [AppData.userType_registrationAccountingDocument.organizationIssuer.name]: 1,
  [AppData.userType_registrationAccountingDocument.documentUsageType.name]: 1,
  [AppData.userType_registrationAccountingDocument.dataSubmissionMethodTvan
    .name]: 1,
}
function CreateRegistration() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { registrationId } = useParams()
  const { pathname } = useLocation()

  const { selectedDigitalCertificate } = useSelector((state) => state.tool)
  const { company, taxAuthorities2025 } = useSelector((state) => state.system)

  const [registration, setRegistration] = useState()
  useEffect(() => {
    if (registration?.provinceCode) {
      dispatch(
        thunkGetTaxAuthority2025({
          provinceCityCode: registration?.provinceCode,
        }),
      )
    }
  }, [dispatch, registration?.provinceCode])

  const systemType = useSelector((s) => s.auth?.activeInvoice)

  const [registrationExisted, setRegistrationExisted] = useState()

  const [selectedCertificates, setSelectedCertificates] = useState([])
  const [showModal, setShowModal] = useState({
    connectConfig: false,
    signatureInfo: false,
    chooseSignMethod: false,
    confirm: false,
    warning: { visible: false, message: '' },
  })
  const [inforSaveAndSign, setInforSaveAndSign] = useState({ disabled: false })
  const screenAction = useMemo(() => pathname?.split('/')?.at(4), [pathname])
  const protoType = useRef(null)

  useLayoutEffect(() => {
    return () => dispatch(setSelectedDigitalCertificate(undefined))
  }, [])

  const userFunction = useSelector((state) => state?.function?.userFunctions)
  const listFunction = useSelector((state) => state?.function?.listFunctions)

  const [themFunction, suaFunction] = useMemo(() => {
    return Utils.checkFunction(
      [
        {
          listFunctionCode: 'TOKHAI_ADD',
        },
        {
          listFunctionCode: 'TOKHAI_EDIT',
        },
      ],
      userFunction,
      listFunction,
    )
  }, [userFunction, listFunction])

  const codeTemplate = useMemo(() => {
    let x = 'x'

    if (registration?.usingOther) x = 5
    if (registration?.usingSale) x = 2
    if (registration?.usingVat) x = 1

    return `M${x}-${dayjs().year() % 100}-${registration?.companyIssuedTaxAuthorityCode || '...'}-${padNumber(registration?.companyCount || 1, 11)}`
  }, [registration])

  const generateCode = (number) => {
    const prefix = 'CT'
    const paddedNumber = String(number).padStart(6, '0')
    return prefix + paddedNumber
  }

  const gotDetailRegistration = useRef(false)
  useEffect(() => {
    if (userFunction?.length && listFunction?.length) {
      if (registrationId) {
        if (!gotDetailRegistration.current)
          (async function () {
            if (!suaFunction) {
              ToastHelper.showError('Bạn không có quyền sửa tờ khai')
              gotDetailRegistration.current = true
              return
            }

            dispatch(setAppSpinning(true))
            var res
            try {
              res = await registrationApi.getDetail(registrationId)
            } catch (e) {
              console.log(e)
            } finally {
              dispatch(setAppSpinning(false))
              gotDetailRegistration.current = true
            }

            if (res?.registration) {
              let { ...rest } = res.registration
              setRegistration({ ...rest })
              setRegistrationExisted(rest)
            }
          })()
      } else {
        if (!Utils.isObjectEmpty(company))
          (async function () {
            if (!themFunction) {
              ToastHelper.showError('Bạn không có quyền thêm tờ khai')
              gotDetailRegistration.current = true
              return
            }

            dispatch(setAppSpinning(true))
            try {
              const params = { params: { registrationType: 'TNCN' } }
              let res = await registrationApi.getPrototype(params)
              console.log('res', res)
              let {
                type,
                no,
                formPosTaxAuthCode,
                formWithTaxAuthCode,
                formWithoutTaxAuthCode,
                transNoTacDirect,
                transNoTacIndirect,
                transTacDiaBanKK,
                transTacUBND,
                transferMethodDetail,
                transferMethodSummary,
                digital_certificates,
                usingVat,
                usingSale,
                usingSalePublicProperty,
                usingSaleNationalReserve,
                usingOther,
                usingBill,

                companyContactPerson,
                companyAddress,
                companyEmail,
                companyPhoneNumber,
              } = res.registration?.registration_1_2 || {}
              protoType.current = res.registration?.registration_3

              dispatch(setAppSpinning(false))
              initialRegistration = {
                ...initialRegistration,
                date: dayjs(new Date()).format('YYYY-MM-DD hh:mm:ss'),
                companyName: company.companyName,
                companyTaxCode: company.taxCode,
                taxAuthorityName: company.taxAuthority?.name,
                taxAuthorityId: company?.taxAuthority?.taxAuthorityId,
                companyContactPerson:
                  companyContactPerson || company.contactPersonName,
                // company?.contactTaxInfo?.fullname ||
                // company.contactPersonName,
                companyAddress: companyAddress || company.businessPermitAddress,
                // company?.contactTaxInfo?.address ||
                // company.businessPermitAddress,
                companyEmail: companyEmail || '',
                // company?.contactTaxInfo?.email ||
                // company.contactPersonEmail,
                companyPhoneNumber: companyPhoneNumber || '',
                // company?.contactTaxInfo?.phone ||
                // company.contactPersonPhone,

                type: type ?? initialRegistration.type,
                no:
                  generateCode(res.registration?.countRegistrationAD + 1) ||
                  initialRegistration.no,
                formPosTaxAuthCode:
                  formPosTaxAuthCode == undefined ? 0 : formPosTaxAuthCode,
                formWithTaxAuthCode:
                  !formWithTaxAuthCode &&
                  !formPosTaxAuthCode &&
                  !formWithoutTaxAuthCode
                    ? 1
                    : formWithTaxAuthCode,
                formWithoutTaxAuthCode:
                  formWithoutTaxAuthCode == undefined
                    ? 0
                    : formWithoutTaxAuthCode,
                transNoTacDirect:
                  transNoTacDirect == undefined ? 0 : transNoTacDirect,
                transNoTacIndirect:
                  transNoTacIndirect == undefined ? 0 : transNoTacIndirect,
                transTacDiaBanKK:
                  transTacDiaBanKK == undefined ? 0 : transTacDiaBanKK,
                transTacUBND: transTacUBND == undefined ? 0 : transTacUBND,
                transferMethodDetail:
                  !formWithTaxAuthCode &&
                  !formPosTaxAuthCode &&
                  !formWithoutTaxAuthCode
                    ? 1
                    : transferMethodDetail,
                transferMethodSummary:
                  transferMethodSummary == undefined
                    ? 0
                    : transferMethodSummary,

                locationName: company?.province?.name,
                digital_certificates,
                usingVat: usingVat ?? initialRegistration.usingVat,
                usingSale: usingSale || 0,
                usingSalePublicProperty: usingSalePublicProperty || 0,
                usingSaleNationalReserve: usingSaleNationalReserve || 0,
                usingOther: usingOther || 0,
                usingBill: usingBill || 0,
              }
              setRegistration(initialRegistration)
            } catch (e) {
              dispatch(setAppSpinning(false))
              console.log(e)
            } finally {
              gotDetailRegistration.current = true
            }
          })()
      }
    }
  }, [registrationId, company, userFunction, listFunction])

  useEffect(() => {
    if (selectedDigitalCertificate) {
      let existed = selectedCertificates
        .concat(registration?.digital_certificates ?? [])
        .find((s) =>
          Utils.shallowEqualCertificate(s, selectedDigitalCertificate),
        )

      if (existed) return
      setSelectedCertificates((old) => [
        ...old,
        { ...selectedDigitalCertificate, type: 1 },
      ])
    }
  }, [selectedDigitalCertificate])

  const hsmSign = async (registrationId) => {
    try {
      dispatch(setAppSpinning(true))
      await registrationApi.hsmSignRegistration({
        registrationId,
        registrationType: 'TNCN',
      })
      dispatch(setAppSpinning(false))
      ToastHelper.showSuccess('Ký tờ khai thành công')
      if (systemType?.invoice) navigate('/hoa-don-dau-ra/to-khai')
      if (systemType?.ticket) navigate('/hoa-don-dau-ra/tem-ve/to-khai')
      if (systemType?.personalIncomeTax)
        navigate('/hoa-don-dau-ra/chung-tu-tncn/to-khai-tncn')
    } catch (e) {
      if (e?.response?.data?.metadata?.disabled)
        handleShowModalWarning(e?.response?.data.message)
    } finally {
      dispatch(setAppSpinning(false))
    }
  }

  async function handlePressedAddDigitalCertificate() {
    // alert('handlePressedAddDigitalCertificate')
    const res = await toolApi.genToolUrl({
      param2: 'addDigitalSignature',
      param3: company.taxCode,
    })
    let { url } = res
    if (url) {
      let notInstalledCb = () => {
        // action
        // alert('Chua cai tool!')
        viewPopupSettingTool()
      }

      customProtocolCheck(
        url,
        notInstalledCb,
        () => {
          Utils.openInCurrentTab(url)
        },
        2500,
      )

      let accessToken = localStorage.getItem(PreferenceKeys.accessToken)
      wsHelperInstance.onAddingDigitalCertificate(accessToken)
    }
  }

  async function handlecreateRegistrationAccountingDocuments() {
    let { digital_certificates, ...params } = registration
    let certificates =
      digital_certificates?.map((cer) => {
        let { registration_cert, ...rest } = cer
        rest.type = registration_cert?.type

        return rest
      }) || []

    certificates.push(...selectedCertificates)

    params = { ...params, certificates, registrationType: 'TNCN' }

    dispatch(setAppSpinning(true))
    var response
    try {
      response =
        await registrationApi.createRegistrationAccountingDocuments(params)
    } catch (e) {
      if (e?.response?.data?.metadata?.disabled)
        handleShowModalWarning(e?.response?.data.message)
    } finally {
      dispatch(setAppSpinning(false))
    }
    await dispatch(
      thunkGetCompanyProfile({ companyId: company?.companyId }),
    ).unwrap()
    console.log('response', response)
    if (response?.registration) {
      if (response?.registration?.type == 3)
        ToastHelper.showSuccess('Chuyển đổi tờ khai thành công')
      else {
        if (screenAction == 'tao') {
          ToastHelper.showSuccess('Tạo tờ khai thành công')
        } else {
          ToastHelper.showSuccess('Chỉnh sửa tờ khai thành công')
        }
        navigate('/hoa-don-dau-ra/chung-tu-tncn/to-khai-tncn')
      }

      if (systemType?.invoice) navigate('/hoa-don-dau-ra/to-khai')
      if (systemType?.ticket) navigate('/hoa-don-dau-ra/tem-ve/to-khai')
    }
  }

  async function handleCreateAndSignRegistration() {
    setInforSaveAndSign({ disabled: true })
    let { digital_certificates, ...params } = registration
    let certificates =
      digital_certificates?.map((cer) => {
        let { registration_cert, ...rest } = cer
        rest.type = registration_cert?.type

        return rest
      }) || []

    certificates.push(...selectedCertificates)

    params = { ...params, certificates, registrationType: 'TNCN' }

    dispatch(setAppSpinning(true))
    var response
    try {
      response =
        await registrationApi.createRegistrationAccountingDocuments(params)
    } catch (e) {
      console.log(e)
      if (e?.response?.data?.metadata?.disabled)
        handleShowModalWarning(e?.response?.data.message)
    } finally {
      setInforSaveAndSign({ disabled: false })
      dispatch(setAppSpinning(false))
    }

    if (response?.registration) {
      const registrationId = response.registration.registrationId

      let activeSigningMethod = company?.activeSigningMethod
      if (activeSigningMethod == 'HSM') {
        await hsmSign(registrationId)
      } else {
        const { url } = await toolApi.genToolUrl({
          param2: 'toKhai100',
          param3: registrationId,
        })
        if (url) {
          let notInstalledCb = () => {
            // alert('Chua cai tool!')
            viewPopupSettingTool()
          }

          customProtocolCheck(
            url,
            notInstalledCb,
            () => {
              Utils.openInCurrentTab(url)
            },
            2500,
          )

          dispatch(setAppSpinning(true))
          wsHelperInstance.onExecutingSignRegistration(registrationId)
          Global.gExecutingSignRegistrationTimeOut = setTimeout(() => {
            dispatch(setAppSpinning(false))
          }, MAX_WAIT_SIGN_INVOICE)
        }
      }
    }
  }

  async function handleUpdateRegistration() {
    let { digital_certificates, ...params } = registration
    let certificates =
      digital_certificates?.map((cer) => {
        let { registration_cert, ...rest } = cer
        rest.type = registration_cert?.type

        return rest
      }) || []

    certificates.push(...selectedCertificates)

    params = { ...params, certificates, registrationType: 'TNCN' }
    dispatch(setAppSpinning(true))
    var response
    try {
      response = await registrationApi.updateRegistrationAccountingDocuments(
        registrationId,
        params,
      )
    } catch (e) {
      if (e?.response?.data?.metadata?.disabled)
        handleShowModalWarning(e?.response?.data.message)
    } finally {
      dispatch(setAppSpinning(false))
    }
    await dispatch(
      thunkGetCompanyProfile({ companyId: company?.companyId }),
    ).unwrap()
    if (response?.registration) {
      ToastHelper.showSuccess('Cập nhật tờ khai thành công')
      navigate('/hoa-don-dau-ra/chung-tu-tncn/to-khai-tncn')
    }
  }

  async function handleUpdateAndSignRegistration() {
    setInforSaveAndSign({ disabled: true })
    let { digital_certificates, ...params } = registration

    let certificates =
      digital_certificates?.map((cer) => {
        let { registration_cert, ...rest } = cer
        rest.type = registration_cert?.type

        return rest
      }) || []
    certificates.push(...selectedCertificates)

    params = { ...params, certificates, registrationType: 'TNCN' }

    dispatch(setAppSpinning(true))
    var response
    try {
      response = await registrationApi.updateRegistrationAccountingDocuments(
        registrationId,
        params,
      )
    } catch (e) {
      console.log(e)
      if (e?.response?.data?.metadata?.disabled)
        handleShowModalWarning(e?.response?.data.message)
    } finally {
      setInforSaveAndSign({ disabled: false })
      dispatch(setAppSpinning(false))
    }

    if (response?.registration) {
      const registrationId = response.registration.registrationId

      let activeSigningMethod = company?.activeSigningMethod
      if (activeSigningMethod == 'HSM') {
        await hsmSign(registrationId)
      } else {
        const { url } = await toolApi.genToolUrl({
          param2: 'toKhai100',
          param3: registrationId,
        })
        if (url) {
          let notInstalledCb = () => {
            // alert('Chua cai tool!')
            viewPopupSettingTool()
          }

          customProtocolCheck(
            url,
            notInstalledCb,
            () => {
              Utils.openInCurrentTab(url)
            },
            2500,
          )

          dispatch(setAppSpinning(true))
          wsHelperInstance.onExecutingSignRegistration(registrationId)
          Global.gExecutingSignRegistrationTimeOut = setTimeout(() => {
            dispatch(setAppSpinning(false))
          }, MAX_WAIT_SIGN_REGISTRATION)
        }
      }
    }
  }

  function changeRegistrationProperty(prop, value) {
    setRegistration((old) => {
      const _registration = { ...old, [prop]: value }
      const {
        formWithTaxAuthCode,
        formWithoutTaxAuthCode,
        formPosTaxAuthCode,

        usingVat,
        usingSale,
        usingSalePublicProperty,
        usingSaleNationalReserve,
        usingOther,
        usingBill,
      } = _registration

      if (
        (!formWithTaxAuthCode &&
          !formWithoutTaxAuthCode &&
          !formPosTaxAuthCode) ||
        (!usingVat &&
          !usingSale &&
          !usingSalePublicProperty &&
          !usingSaleNationalReserve &&
          !usingOther &&
          !usingBill)
      )
        return old

      if (prop == 'type') {
        if (!protoType.current?.no && value == 3)
          return { ..._registration, no: '' }
        if (!protoType.current?.no && value != 3)
          return { ..._registration, no: initialRegistration.no }
        if (protoType.current?.no && value == 3)
          return { ..._registration, no: protoType.current?.no }
      }
      return _registration
    })
  }

  function changeModalProperty(prop, value) {
    setShowModal((old) => ({ ...old, [prop]: value }))
  }

  function changeCertType(certsName, index, value) {
    if (certsName == 'selectedCertificates') {
      setSelectedCertificates((old) =>
        old.map((item, i) => (i == index ? { ...item, type: value } : item)),
      )
    } else if (certsName == 'digital_certificates') {
      setRegistration((old) => ({
        ...old,
        digital_certificates: old.digital_certificates.map((item, i) =>
          i == index
            ? {
                ...item,
                registration_cert: { ...item.registration_cert, type: value },
              }
            : item,
        ),
      }))
    }
  }

  async function handlePrintRegistration() {
    let { digital_certificates, ...params } = registration

    let certificates =
      digital_certificates?.map((cer) => {
        let { registration_cert, ...rest } = cer
        rest.type = registration_cert?.type

        return rest
      }) || []
    certificates.push(...selectedCertificates)
    params = { ...params, certificates, registrationType: 'TNCN' }
    let res

    dispatch(setAppSpinning(true))
    try {
      res = await registrationApi.exportRegistrationAccountingDocuments(params)
      let newFile = new File(
        [res],
        'Tờ khai đăng ký/thay đổi thông tin sử dụng hóa đơn.pdf',
        {
          type: 'application/pdf',
        },
      )
      var fileURL = URL.createObjectURL(newFile)
      window.open(fileURL, '_blank')
    } catch (e) {
      console.log(e)
    } finally {
      dispatch(setAppSpinning(false))
    }
  }

  async function handleAddDigitalCertificateHSM(values) {
    dispatch(setAppSpinning(true))
    try {
      let res = await registrationApi.getCertificateDetailHSM({
        hsmAgreementUUID: values.agreementUUID,
      })
      dispatch(setAppSpinning(false))
      if (res?.result == 'success') {
        res = res.data

        dispatch(setSelectedDigitalCertificate(res))
        changeModalProperty('connectConfig', false)
      }
    } catch (e) {
      dispatch(setAppSpinning(false))
      throw new Error(e.message)
    }
  }

  async function handleAddDigitalCertificateMannual(values) {
    dispatch(setSelectedDigitalCertificate(values))
    changeModalProperty('signatureInfo', false)
  }

  function handleShowModalChooseSignMethod() {
    changeModalProperty('chooseSignMethod', true)
  }

  const { data: banners, isLoading } = useQuery({
    staleTime: 1000 * 60 * 5,
    queryKey: ['banner'],
    queryFn: ({ signal }) =>
      axiosClient.get('/notification-marquee/show', {
        signal,
      }),
  })

  if (isLoading) {
    return null
  }

  function handleShowModalWarning(_message) {
    changeModalProperty('warning', { visible: true, message: _message })
  }

  useEffect(() => {
    if (taxAuthorities2025 && registration?.taxAuthorityId) {
      let taxAuthorities = findObjectInArray(
        taxAuthorities2025,
        'taxAuthorityId',
        registration?.taxAuthorityId,
      )
      setRegistration({
        ...registration,
        provinceCode: taxAuthorities?.provinceId,
      })
    }
  }, [taxAuthorities2025, registration?.taxAuthorityId])

  return (
    <div className="CreateRegistration">
      <PrivateBaseLayout nonPadding nonPageUpBtn>
        {registration && (
          <>
            <div className="registration-container mb-5">
              <div className="registration-paper mx-auto">
                <div className="d-flex flex-column justify-content-center">
                  <div className="text-center pt-5">
                    <div
                      className="text-uppercase font-sfpro-bold"
                      style={{ fontSize: '20px', fontWeight: '400' }}
                    >
                      Tờ khai
                    </div>

                    <div
                      className="font-sfpro-bold"
                      style={{ fontSize: '16px', fontWeight: '400' }}
                    >
                      Đăng ký/Thay đổi thông tin sử dụng chứng từ điện tử
                    </div>

                    <div
                      className="d-flex justify-content-center align-items-end"
                      style={{ minHeight: '44px', paddingBottom: '8px' }}
                    >
                      {registrationType?.map((item, index) => {
                        if (
                          screenAction == 'sua' &&
                          registrationExisted?.type == 3 &&
                          (item.value == 1 || item.value == 2)
                        )
                          return
                        return (
                          <div key={index} className="form-check mr-5">
                            <input
                              className="form-check-input cursor-pointer"
                              type="radio"
                              name={`registration-${item.value}`}
                              id={`registration-${item.value}`}
                              value={item.value}
                              readOnly={screenAction == 'xem'}
                              checked={registration.type == item.value}
                              onChange={(e) => {
                                setRegistration({
                                  ...registration,
                                  type: e.target.value,
                                })
                              }}
                              disabled={registrationExisted?.type == 3}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`registration-${item.value}`}
                            >
                              {item.label}
                            </label>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="registration-label">Số quyết định:</div>
                  <div>
                    <input
                      type="text"
                      className="form-control input-dot"
                      readOnly={screenAction == 'xem'}
                      value={registration.no}
                      onChange={(e) =>
                        setRegistration({
                          ...registration,
                          no: e.target.value?.trim(),
                        })
                      }
                      required
                    />
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="registration-label">Ngày lập:</div>
                  <div>
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      customInput={
                        <input
                          type="text"
                          className="form-control input-dot input-date"
                        />
                      }
                      onChangeRaw={(e) => {
                        const newDate = dayjs(
                          e?.target?.value?.trim(),
                          'DD/MM/YYYY',
                          true,
                        )
                        console.log('newDate', newDate)
                        if (newDate.isValid()) {
                          setRegistration({
                            ...registration,
                            date: newDate.toDate(), // hoặc format nếu bạn cần string
                          })
                        } else {
                          console.warn('Invalid date format')
                        }
                      }}
                      // showIcon={true}
                      todayButton={<button>Hôm nay</button>}
                      readOnly={screenAction == 'xem'}
                      selected={new Date(registration.date) || new Date()}
                      onChange={(date) => {
                        date &&
                          setRegistration({
                            ...registration,
                            date: dayjs(date).format('YYYY-MM-DD HH:mm:ss'), // hoặc format nếu bạn cần string
                          })
                      }}
                    />
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="registration-label">Tên người nộp thuế:</div>
                  <div>{registration.companyName}</div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="registration-label">Mã số thuế:</div>
                  <div className="d-flex flex-row align-items-center tax-code">
                    <div className="d-flex flex-row align-items-center tax-code-input mr-2">
                      {registration.companyTaxCode
                        .split('-')
                        .at(0)
                        .split('')
                        .map((num, index) => (
                          <div key={index} className="tax-code-number">
                            {num}
                          </div>
                        ))}
                    </div>
                    <div className="d-flex flex-row align-items-center tax-code-input">
                      {(registration.companyTaxCode.split('-').at(1) || '   ')
                        .split('')
                        .map((num, index) => (
                          <div key={index} className="tax-code-number">
                            {num}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '12px' }}
                >
                  <div
                    className="registration-label"
                    style={{ lineHeight: '5px' }}
                  >
                    <p>Cơ quan thuế quản</p> lý:
                    <span className="text-danger">*</span>{' '}
                  </div>
                  <div className="flex-grow-1">
                    <input
                      defaultValue={registration.taxAuthorityName}
                      type="text"
                      className="form-control input-dot"
                      disabled
                      style={{ display: 'none' }}
                    />
                    <SelectCustom
                      style={{ width: '100%' }}
                      options={taxAuthorities2025.map((item) => ({
                        value: item.taxAuthorityId,
                        label: item.name,
                      }))}
                      notFoundContent={
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description={t('taxDeduction.noData')}
                        />
                      }
                      onChange={(value) => {
                        let dataOption = findObjectInArray(
                          taxAuthorities2025,
                          'taxAuthorityId',
                          value,
                        )
                        setRegistration({
                          ...registration,
                          taxAuthorityName: dataOption?.name,
                          taxAuthorityId: value,
                        })
                      }}
                      value={registration.taxAuthorityId}
                    ></SelectCustom>
                  </div>
                </div>
                <div
                  className="d-flex flex-row align-items-center p-3"
                  style={{
                    fontSize: '13.5px',
                    fontStyle: 'italic',
                    backgroundColor: '#eaff0e63',
                  }}
                >
                  <div className="mr-2">
                    <i
                      className="fa-solid fa-lightbulb-on fa-lg"
                      style={{ color: '#efd358' }}
                    ></i>
                  </div>
                  <div className="remind">
                    <p className="mb-0 remind-subtitle">
                      Sau khi tờ khai được <b>chấp nhận</b>, cơ quan thuế sẽ{' '}
                      <b>gửi các thông báo quan trọng</b> liên quan đến hóa đơn
                      điện tử tới email/số điện thoại/địa chỉ này.
                    </p>
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="registration-label">
                    Người liên hệ:
                    <span className="text-danger">*</span>
                  </div>
                  <div className="" style={{ flexBasis: 'auto' }}>
                    <input
                      type="text"
                      className="form-control input-dot"
                      style={{ flex: 'auto' }}
                      value={registration.companyContactPerson}
                      readOnly={screenAction == 'xem'}
                      onBlur={(e) =>
                        // changeRegistrationProperty(
                        //   'companyContactPerson',
                        //   e.target.value?.trim(),
                        // )
                        setRegistration({
                          ...registration,
                          companyContactPerson: e.target.value,
                        })
                      }
                      onChange={
                        (e) =>
                          setRegistration({
                            ...registration,
                            companyContactPerson: e.target.value,
                          })
                        // changeRegistrationProperty(
                        //   'companyContactPerson',
                        //   e.target.value,
                        // )
                      }
                    />
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="registration-label">
                    Địa chỉ liên hệ:
                    <span className="text-danger">*</span>
                  </div>
                  <div className="flex-grow-1">
                    <input
                      type="text"
                      className="form-control input-dot"
                      value={registration.companyAddress}
                      readOnly={screenAction == 'xem'}
                      onBlur={(e) =>
                        // changeRegistrationProperty(
                        //   'companyAddress',
                        //   e.target.value?.trim(),
                        // )
                        setRegistration({
                          ...registration,
                          companyAddress: e.target.value?.trim(),
                        })
                      }
                      onChange={(e) =>
                        // changeRegistrationProperty(
                        //   'companyAddress',
                        //   e.target.value,
                        // )
                        setRegistration({
                          ...registration,
                          companyAddress: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="registration-label">
                    Thư điện tử:
                    <span className="text-danger">*</span>
                  </div>
                  <div className="" style={{ flexBasis: 'auto' }}>
                    <input
                      type="text"
                      className="form-control input-dot"
                      readOnly={screenAction == 'xem'}
                      value={registration.companyEmail}
                      onBlur={(e) => {
                        // changeRegistrationProperty(
                        //   'companyEmail',
                        //   e.target.value?.trim(),
                        // )
                        setRegistration({
                          ...registration,
                          companyEmail: e.target.value?.trim(),
                        })
                      }}
                      onChange={(e) =>
                        // changeRegistrationProperty(
                        //   'companyEmail',
                        //   e.target.value,
                        // )
                        setRegistration({
                          ...registration,
                          companyEmail: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="registration-label">
                    Điện thoại liên hệ:
                    <span className="text-danger">*</span>
                  </div>
                  <div className="" style={{ flexBasis: 'auto' }}>
                    <input
                      type="text"
                      className="form-control input-dot"
                      readOnly={screenAction == 'xem'}
                      value={registration.companyPhoneNumber}
                      onBlur={
                        (e) =>
                          setRegistration({
                            ...registration,
                            companyPhoneNumber: e.target.value?.trim(),
                          })
                        // changeRegistrationProperty(
                        //   'companyPhoneNumber',
                        //   e.target.value?.trim(),
                        // )
                      }
                      onChange={
                        (e) =>
                          setRegistration({
                            ...registration,
                            companyPhoneNumber: e.target.value,
                          })
                        // changeRegistrationProperty(
                        //   'companyPhoneNumber',
                        //   e.target.value,
                        // )
                      }
                    />
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  Theo nghị định số 70/2025/NĐ-CP ngày 20 tháng 03 năm 2025 của
                  Chính phủ, chúng tôi/tôi thuộc đối tượng sử dụng chứng từ điện
                  tử. Chúng tôi/tôi đăng ký/thay đổi thông tin đã đăng ký với cơ
                  quan thuế về việc sử dụng chứng từ điện tử như sau:
                </div>
                <div>
                  <div
                    className="d-flex align-items-end font-sfpro-bold"
                    style={{ minHeight: '44px', paddingBottom: '8px' }}
                  >
                    1. Đối tượng phát hành
                  </div>
                  <div style={{ marginLeft: '24px' }}>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .organizationIssuer.name
                          ]
                        }
                        id={
                          AppData.userType_registrationAccountingDocument
                            .organizationIssuer.name
                        }
                        checked={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .organizationIssuer.name
                          ]
                        }
                        disabled={true}
                        readOnly={screenAction == 'xem'}
                        onChange={(e) => {
                          let checkValue = e.target.checked ? 1 : 0
                          setRegistration({
                            ...registration,
                            [AppData.userType_registrationAccountingDocument
                              .organizationIssuer.name]: checkValue,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={
                          AppData.userType_registrationAccountingDocument
                            .organizationIssuer.name
                        }
                      >
                        {
                          AppData.userType_registrationAccountingDocument
                            .organizationIssuer.label
                        }
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .taxAgency.name
                          ]
                        }
                        id={
                          AppData.userType_registrationAccountingDocument
                            .taxAgency.name
                        }
                        checked={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .taxAgency.name
                          ]
                        }
                        disabled={true}
                        readOnly={screenAction == 'xem'}
                        onChange={(e) => {
                          let checkValue = e.target.checked ? 1 : 0
                          setRegistration({
                            ...registration,
                            [AppData.userType_registrationAccountingDocument
                              .taxAgency.name]: checkValue,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={
                          AppData.userType_registrationAccountingDocument
                            .taxAgency.name
                        }
                      >
                        {
                          AppData.userType_registrationAccountingDocument
                            .taxAgency.label
                        }
                      </label>
                    </div>
                  </div>
                </div>

                <div>
                  <div
                    className="d-flex align-items-end font-sfpro-bold"
                    style={{ minHeight: '44px', paddingBottom: '8px' }}
                  >
                    2. Loại hình sử dụng
                  </div>
                  <div style={{ marginLeft: '24px' }}>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .documentUsageType.name
                          ]
                        }
                        id={
                          AppData.userType_registrationAccountingDocument
                            .documentUsageType.name
                        }
                        checked={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .documentUsageType.name
                          ]
                        }
                        disabled={true}
                        readOnly={screenAction == 'xem'}
                        onChange={(e) => {
                          let checkValue = e.target.checked ? 1 : 0
                          setRegistration({
                            ...registration,
                            [AppData.userType_registrationAccountingDocument
                              .documentUsageType.name]: checkValue,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={
                          AppData.userType_registrationAccountingDocument
                            .documentUsageType.name
                        }
                      >
                        {
                          AppData.userType_registrationAccountingDocument
                            .documentUsageType.label
                        }
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .ecommerceWithholdingDocType.name
                          ]
                        }
                        id={
                          AppData.userType_registrationAccountingDocument
                            .ecommerceWithholdingDocType.name
                        }
                        checked={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .ecommerceWithholdingDocType.name
                          ]
                        }
                        readOnly={screenAction == 'xem'}
                        onChange={(e) => {
                          let checkValue = e.target.checked ? 1 : 0
                          setRegistration({
                            ...registration,
                            [AppData.userType_registrationAccountingDocument
                              .ecommerceWithholdingDocType.name]: checkValue,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={
                          AppData.userType_registrationAccountingDocument
                            .ecommerceWithholdingDocType.name
                        }
                      >
                        {
                          AppData.userType_registrationAccountingDocument
                            .ecommerceWithholdingDocType.label
                        }
                      </label>
                    </div>
                    <div
                      className="form-check"
                      style={{ pointerEvents: 'none', opacity: 0.5 }}
                    >
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .eReceiptServiceType.name
                          ]
                        }
                        id={
                          AppData.userType_registrationAccountingDocument
                            .eReceiptServiceType.name
                        }
                        checked={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .eReceiptServiceType.name
                          ]
                        }
                        readOnly={screenAction == 'xem'}
                        onChange={(e) => {
                          let checkValue = e.target.checked ? 1 : 0
                          let nameOption =
                            AppData.userType_registrationAccountingDocument
                              .eReceiptServiceType.nameOption
                          setRegistration({
                            ...registration,
                            [AppData.userType_registrationAccountingDocument
                              .eReceiptServiceType.name]: checkValue,
                            [nameOption]:
                              registration?.[nameOption] ??
                              AppData.userType_registrationAccountingDocument
                                .eReceiptServiceType.option?.[0]?.value,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={
                          AppData.userType_registrationAccountingDocument
                            .eReceiptServiceType.name
                        }
                      >
                        {
                          AppData.userType_registrationAccountingDocument
                            .eReceiptServiceType.label
                        }
                      </label>
                      <div></div>
                    </div>
                    <Radio.Group
                      disabled={
                        !registration?.[
                          AppData.userType_registrationAccountingDocument
                            .eReceiptServiceType.name
                        ]
                      }
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8,
                        marginLeft: 35,
                      }}
                      onChange={(e) => {
                        setRegistration({
                          ...registration,
                          [AppData.userType_registrationAccountingDocument
                            .eReceiptServiceType.nameOption]: e.target.value,
                        })
                      }}
                      value={
                        registration?.[
                          AppData.userType_registrationAccountingDocument
                            .eReceiptServiceType.name
                        ]
                          ? registration?.[
                              AppData.userType_registrationAccountingDocument
                                .eReceiptServiceType.nameOption
                            ]
                          : null
                      }
                      options={
                        AppData.userType_registrationAccountingDocument
                          .eReceiptServiceType.option
                      }
                    />
                  </div>
                </div>
                <div className="taxpayer">
                  <div
                    className="d-flex align-items-end font-sfpro-bold"
                    style={{ minHeight: '44px', paddingBottom: '8px' }}
                  >
                    3. Hình thức gửi dữ liệu:
                  </div>
                  {/* <div
                    className="d-flex flex-row align-items-center p-3"
                    style={{
                      fontSize: '13.5px',
                      fontStyle: 'italic',
                      backgroundColor: '#eaff0e63',
                    }}
                  >
                    <div className="mr-2">
                      <i
                        className="fa-solid fa-lightbulb-on fa-lg"
                        style={{ color: '#efd358' }}
                      ></i>
                    </div>
                    <div className="remind">
                      <p className="mb-0 remind-subtitle">
                        Vui lòng bỏ qua nếu bạn không thuộc đối tượng nào trong
                        các đối tượng dưới đây.
                      </p>
                    </div>
                  </div> */}
                  <div style={{ marginLeft: '24px' }}>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .dataSubmissionMethodPortal.name
                          ]
                        }
                        id={
                          AppData.userType_registrationAccountingDocument
                            .dataSubmissionMethodPortal.name
                        }
                        checked={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .dataSubmissionMethodPortal.name
                          ]
                        }
                        readOnly={screenAction == 'xem'}
                        onChange={(e) => {
                          let checkValue = e.target.checked ? 1 : 0
                          setRegistration({
                            ...registration,
                            [AppData.userType_registrationAccountingDocument
                              .dataSubmissionMethodPortal.name]: checkValue,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={
                          AppData.userType_registrationAccountingDocument
                            .dataSubmissionMethodPortal.name
                        }
                      >
                        a.{' '}
                        {
                          AppData.userType_registrationAccountingDocument
                            .dataSubmissionMethodPortal.label
                        }
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .dataSubmissionMethodTvan.name
                          ]
                        }
                        id={
                          AppData.userType_registrationAccountingDocument
                            .dataSubmissionMethodTvan.name
                        }
                        checked={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .dataSubmissionMethodTvan.name
                          ]
                        }
                        disabled={true}
                        readOnly={screenAction == 'xem'}
                        onChange={(e) => {
                          let checkValue = e.target.checked ? 1 : 0
                          setRegistration({
                            ...registration,
                            [AppData.userType_registrationAccountingDocument
                              .dataSubmissionMethodTvan.name]: checkValue,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={
                          AppData.userType_registrationAccountingDocument
                            .dataSubmissionMethodTvan.name
                        }
                      >
                        b.{' '}
                        {
                          AppData.userType_registrationAccountingDocument
                            .dataSubmissionMethodTvan.label
                        }
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .dataSubmissionMethodTvanAuthorized.name
                          ]
                        }
                        id={
                          AppData.userType_registrationAccountingDocument
                            .dataSubmissionMethodTvanAuthorized.name
                        }
                        checked={
                          registration?.[
                            AppData.userType_registrationAccountingDocument
                              .dataSubmissionMethodTvanAuthorized.name
                          ]
                        }
                        readOnly={screenAction == 'xem'}
                        onChange={(e) => {
                          let checkValue = e.target.checked ? 1 : 0
                          setRegistration({
                            ...registration,
                            [AppData.userType_registrationAccountingDocument
                              .dataSubmissionMethodTvanAuthorized.name]:
                              checkValue,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={
                          AppData.userType_registrationAccountingDocument
                            .dataSubmissionMethodTvanAuthorized.name
                        }
                      >
                        c.{' '}
                        {
                          AppData.userType_registrationAccountingDocument
                            .dataSubmissionMethodTvanAuthorized.label
                        }
                      </label>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    className="d-flex align-items-end font-sfpro-bold"
                    style={{ minHeight: '44px', paddingBottom: '8px' }}
                  >
                    4. Danh sách chứng thư số sử dụng
                  </div>
                  <div className="digital-certificate">
                    <table className="table table-bordered">
                      <thead>
                        <tr role="row">
                          <th scope="col" rowSpan="2" colSpan="1">
                            STT
                          </th>
                          <th scope="col" rowSpan="2" colSpan="1">
                            Tên tổ chức cơ quan chứng thực/cấp/công nhận chữ ký
                            số, chữ ký điện tử
                          </th>
                          <th scope="col" rowSpan="2" colSpan="1">
                            Số sê-ri chứng thư
                          </th>
                          <th scope="col" rowSpan="1" colSpan="2">
                            Thời hạn sử dụng chứng thư số
                          </th>
                          <th scope="col" rowSpan="2" colSpan="1">
                            Hình thức đăng ký (Thêm mới, gia hạn, ngừng sử dụng)
                          </th>
                          <th
                            scope="col"
                            rowSpan="2"
                            colSpan="1"
                            style={{ width: '70px' }}
                          >
                            {selectedCertificates.length == 0 &&
                              (!registration?.digital_certificates ||
                                registration?.digital_certificates?.length ==
                                  0) && (
                                <div>
                                  <i
                                    className="fal fa-plus mr-4 cursor-pointer mx-auto"
                                    onClick={
                                      screenAction != 'xem' &&
                                      handleShowModalChooseSignMethod
                                    }
                                  ></i>
                                </div>
                              )}
                          </th>
                        </tr>
                        <tr role="row">
                          <th scope="col" rowSpan="1" colSpan="1">
                            Từ ngày
                          </th>
                          <th scope="col" rowSpan="1" colSpan="1">
                            Đến ngày
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {registration.digital_certificates?.map(
                          (certificate, index, arr) => (
                            <tr key={index}>
                              <th scope="row">{index + 1}</th>
                              <td>
                                <Tooltip title={certificate.issuedBy}>
                                  <div
                                    style={{
                                      display: '-webkit-box',
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: 'vertical',
                                      overflow: 'hidden',
                                      wordBreak: 'break-word',
                                    }}
                                  >
                                    {certificate.issuedBy}
                                  </div>
                                </Tooltip>
                              </td>
                              <td>
                                <Tooltip title={certificate.idValue}>
                                  <div
                                    style={{
                                      display: '-webkit-box',
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: 'vertical',
                                      overflow: 'hidden',
                                      wordBreak: 'break-word',
                                    }}
                                  >
                                    {certificate.idValue}
                                  </div>
                                </Tooltip>
                              </td>
                              <td>
                                {dayjs(certificate.issuedDate).format(
                                  'DD/MM/YYYY',
                                )}
                              </td>
                              <td>
                                {dayjs(certificate.expireDate).format(
                                  'DD/MM/YYYY',
                                )}
                              </td>
                              <td>
                                <CustomSelect
                                  value={cerTypeOptions.find(
                                    ({ value }) =>
                                      value ==
                                      certificate.registration_cert?.type,
                                  )}
                                  onChange={({ value }) =>
                                    changeCertType(
                                      'digital_certificates',
                                      index,
                                      value,
                                    )
                                  }
                                  options={cerTypeOptions}
                                />
                              </td>
                              <td>
                                <div>
                                  {!selectedCertificates?.length &&
                                    index === arr.length - 1 && (
                                      <i
                                        className="fal fa-plus mr-4 cursor-pointer"
                                        onClick={
                                          screenAction != 'xem' &&
                                          handleShowModalChooseSignMethod
                                        }
                                      ></i>
                                    )}
                                  <i
                                    className="far fa-trash-alt cursor-pointer"
                                    onClick={() => {
                                      setRegistration((old) => ({
                                        ...old,
                                        digital_certificates:
                                          old.digital_certificates.filter(
                                            (cer) =>
                                              cer.idValue !=
                                              certificate.idValue,
                                          ),
                                      }))
                                    }}
                                  ></i>
                                </div>
                              </td>
                            </tr>
                          ),
                        )}
                        {selectedCertificates.map((certificate, index, arr) => (
                          <tr key={index}>
                            <th scope="row">
                              {(registration?.digital_certificates?.length ||
                                0) +
                                index +
                                1}
                            </th>
                            <td>
                              <Tooltip title={certificate.issuedBy}>
                                <div
                                  style={{
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    wordBreak: 'break-word',
                                  }}
                                >
                                  {certificate.issuedBy}
                                </div>
                              </Tooltip>
                            </td>
                            <td>
                              <Tooltip title={certificate.idValue}>
                                <div
                                  style={{
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    wordBreak: 'break-word',
                                  }}
                                >
                                  {certificate.idValue}
                                </div>
                              </Tooltip>
                            </td>
                            <td>
                              {dayjs(certificate.issuedDate).format(
                                'DD/MM/YYYY',
                              )}
                            </td>
                            <td>
                              {dayjs(certificate.expireDate).format(
                                'DD/MM/YYYY',
                              )}
                            </td>
                            <td>
                              <CustomSelect
                                value={cerTypeOptions.find(
                                  ({ value }) => value == certificate?.type,
                                )}
                                onChange={({ value }) =>
                                  changeCertType(
                                    'selectedCertificates',
                                    index,
                                    value,
                                  )
                                }
                                options={cerTypeOptions}
                              />
                            </td>
                            <td>
                              <div>
                                {index === arr.length - 1 && (
                                  <i
                                    className="fal fa-plus mr-4 cursor-pointer"
                                    onClick={
                                      screenAction != 'xem' &&
                                      handleShowModalChooseSignMethod
                                    }
                                  ></i>
                                )}
                                <i
                                  className="far fa-trash-alt cursor-pointer"
                                  onClick={() =>
                                    setSelectedCertificates((old) =>
                                      old.filter(
                                        (cer) =>
                                          cer.idValue != certificate.idValue,
                                      ),
                                    )
                                  }
                                ></i>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div style={{ pointerEvents: 'none', opacity: 0.5 }}>
                  <div
                    className="d-flex align-items-end font-sfpro-bold"
                    style={{
                      minHeight: '44px',
                      paddingBottom: '8px',
                    }}
                  >
                    5. Đăng ký ủy nhiệm lập biên lai
                  </div>
                  <div className="digital-certificate">
                    <table className="table table-bordered">
                      <thead>
                        <tr role="row">
                          <th scope="col" rowSpan="1" colSpan="1">
                            STT
                          </th>
                          <th scope="col" rowSpan="1" colSpan="1">
                            Tên loại biên lai ủy nhiệm
                          </th>
                          <th scope="col" rowSpan="1" colSpan="1">
                            Ký hiệu mẫu biên lai ủy nhiệm
                          </th>
                          <th scope="col" rowSpan="1" colSpan="1">
                            Tên tổ chức được ủy nhiệm/tổ chức ủy nhiệm
                          </th>
                          <th scope="col" rowSpan="1" colSpan="1">
                            Thời hạn ủy nhiệm
                          </th>
                          <th scope="col" rowSpan="1" colSpan="1">
                            Phương thức thanh toán biên lai ủy nhiệm
                          </th>
                          <th style={{ width: 70 }}>
                            <div>
                              <i className="fal fa-plus mr-4 cursor-pointer mx-auto"></i>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      {/* <tbody>
                        <tr>
                          <th scope="row">1</th>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            <div>
                              <i className="fal fa-plus mr-4 cursor-pointer"></i>
                              <i className="far fa-trash-alt cursor-pointer"></i>
                            </div>
                          </td>
                        </tr>
                      </tbody> */}
                    </table>
                  </div>
                </div>
                {/*Hiển thị khi chọn Cập nhật thông tin tờ khai từ hệ thống khác */}
                {registration.type == 3 &&
                  registration.formPosTaxAuthCode == 1 && (
                    <div>
                      <div
                        className="d-flex align-items-end font-sfpro-bold "
                        style={{ minHeight: '44px', paddingBottom: '8px' }}
                      >
                        <span>6. Cập nhật mã CQT</span>
                        <Tooltip
                          overlayStyle={{ maxWidth: '454px' }}
                          placement="topLeft"
                          title={() => {
                            return (
                              <div>
                                <ul>
                                  <li>
                                    Mã CQT gồm 5 ký tự áp dụng với hóa đơn khởi
                                    tạo từ MTT.
                                  </li>
                                  <li>
                                    Số thứ tự bắt đầu: Là số kế tiếp của mã CQT
                                    khi chuyển HĐ sang hệ thống mới.
                                  </li>
                                </ul>
                              </div>
                            )
                          }}
                          color=" #000000BF"
                        >
                          <InfoCircleOutlined
                            style={{
                              paddingBottom: '4px',
                              paddingLeft: '10px',
                            }}
                          />
                        </Tooltip>
                      </div>
                      <div style={{ marginLeft: '24px' }}>
                        <div
                          className="d-flex align-items-center"
                          style={{ minHeight: '44px', paddingBottom: '8px' }}
                        >
                          <div className="registration-label">
                            Mã CQT cấp:
                            <span className="text-danger">*</span>
                          </div>
                          <div className="" style={{ flexBasis: 'auto' }}>
                            <input
                              type="text"
                              className="form-control"
                              style={{ flex: 'auto', minWidth: '250px' }}
                              value={registration.companyIssuedTaxAuthorityCode}
                              readOnly={screenAction == 'xem'}
                              onChange={(e) => {
                                changeRegistrationProperty(
                                  'companyIssuedTaxAuthorityCode',
                                  Utils.convertString(
                                    e.target.value.trim(),
                                  ).toUpperCase(),
                                )
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className="d-flex align-items-center"
                          style={{ minHeight: '44px', paddingBottom: '8px' }}
                        >
                          <div
                            className="d-flex align-items-center"
                            style={{
                              minHeight: '44px',
                              paddingBottom: '8px',
                            }}
                          >
                            <div className="registration-label">
                              Số thứ tự bắt đầu
                              <span className="text-danger">*</span>
                            </div>
                            <div className="" style={{ flexBasis: 'auto' }}>
                              <input
                                min={1}
                                type="number"
                                className="form-control "
                                style={{ flex: 'auto', width: '80px' }}
                                value={registration.companyCount}
                                readOnly={screenAction == 'xem'}
                                onChange={(e) => {
                                  let _value = e?.target?.value
                                  if (_value && _value < 1) _value = 1
                                  changeRegistrationProperty(
                                    'companyCount',
                                    _value,
                                  )
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="d-flex align-items-center"
                          style={{ minHeight: '44px', paddingBottom: '8px' }}
                        >
                          <div
                            className="d-flex align-items-center"
                            style={{
                              minHeight: '44px',
                              paddingBottom: '8px',
                            }}
                          >
                            <div className="registration-label">
                              Mẫu hiển thị:
                            </div>
                            <div className="" style={{ flexBasis: 'auto' }}>
                              <input
                                type="text"
                                className="form-control"
                                style={{ flex: 'auto', minWidth: '250px' }}
                                value={codeTemplate}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  Chúng tôi cam kết hoàn toàn chịu trách nhiệm trước pháp luật
                  về tính chính xác, trung thực của nội dung nêu trên và thực
                  hiện theo đúng quy định của pháp luật.
                </div>

                {/*Ẩn khi chọn Cập nhật thông tin tờ khai từ hệ thống khác */}
                {registration.type != 3 && (
                  <div className="d-flex flex-row justify-content-between align-items-start">
                    <div>
                      <div
                        className="d-flex align-items-end"
                        style={{ minHeight: '44px', paddingBottom: '8px' }}
                      >
                        <div className="registration-label">Nơi lập:</div>
                        <div>
                          <input
                            type="text"
                            className="form-control input-dot"
                            value={registration.locationName}
                            readOnly={screenAction == 'xem'}
                            onBlur={(e) => {
                              changeRegistrationProperty(
                                'locationName',
                                e?.target?.value?.trim(),
                              )
                            }}
                            maxLength={50}
                            onChange={(e) =>
                              changeRegistrationProperty(
                                'locationName',
                                e?.target?.value,
                              )
                            }
                          />
                        </div>
                      </div>
                      {/* <div
              className="d-flex align-items-end"
              style={{ minHeight: '44px', paddingBottom: '8px' }}
            >
              <div className="registration-label">Ngày có hiệu lực:</div>
              <div>
                <input defaultValue="29/03/2023" type="text" className="form-control input-dot" />
              </div>
            </div> */}
                    </div>

                    <div className="text-center">
                      <div>{`${registration.locationName}, ngày ${dayjs(
                        registration.date,
                      ).format('DD/MM/YYYY')}`}</div>
                      <div>
                        <div className="font-sfpro-bold">NGƯỜI NỘP THUẾ</div>
                        <div className="mb-4">
                          (Chữ ký số, chữ ký điện tử của người nộp thuế)
                        </div>
                        <button
                          className="btn btn-light d-inline-flex align-items-center"
                          style={{
                            color: '#041847',
                            backgroundColor: '#e4e6eb',
                          }}
                          onClick={
                            screenAction == 'tao'
                              ? handleCreateAndSignRegistration
                              : handleUpdateAndSignRegistration
                          }
                        >
                          <i
                            className="fal fa-file-contract"
                            style={{ color: '#041847' }}
                          ></i>
                          Ký điện tử
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div
              className="registration-footer d-flex flex-row justify-content-between align-items-center px-6 py-2 border-top border-secondary"
              style={banners?.data?.length > 0 ? { bottom: '30px' } : {}}
            >
              <button
                className="btn btn-secondary"
                onClick={() => navigate(-1)}
              >
                <i className="fa-sharp fa-regular fa-arrow-left"></i>Quay lại
              </button>
              {registration.type != 3 && (
                <button
                  className="btn btn-secondary"
                  onClick={handlePrintRegistration}
                >
                  <i className="fa-regular fa-print"></i>In
                </button>
              )}

              <div className="d-flex flex-row">
                {/* Ẩn khi chọn Cập nhật thông tin tờ khai từ hệ thống khác */}
                {screenAction != 'xem' && registration?.type != 3 && (
                  <button
                    className="btn btn-primary d-flex flex-row align-items-center py-2 mr-2"
                    disabled={inforSaveAndSign?.disabled}
                    onClick={
                      screenAction == 'tao'
                        ? handleCreateAndSignRegistration
                        : handleUpdateAndSignRegistration
                    }
                  >
                    <i className="fa-regular fa-pen-to-square"></i>Lưu và ký
                  </button>
                )}
                {screenAction != 'xem' && (
                  <button
                    className="btn btn-primary d-flex flex-row align-items-center py-2"
                    onClick={() => {
                      if (registration?.type != 3) {
                        screenAction == 'sua'
                          ? handleUpdateRegistration()
                          : handlecreateRegistrationAccountingDocuments()
                      } else changeModalProperty('confirm', true)
                    }}
                  >
                    <i className="fa-regular fa-check"></i>Lưu
                  </button>
                )}
              </div>
            </div>
          </>
        )}
      </PrivateBaseLayout>

      <ModalConnectConfig
        title={'Nhập thông tin chữ ký số HSM'}
        method={'HSM'}
        requirePassCode={false}
        open={!!showModal.connectConfig}
        onOpenChange={(state) => changeModalProperty('connectConfig', state)}
        onApply={handleAddDigitalCertificateHSM}
      />

      <ModalSignatureInfo
        open={!!showModal.signatureInfo}
        onOpenChange={(state) => changeModalProperty('signatureInfo', state)}
        onApply={handleAddDigitalCertificateMannual}
      />

      <ModalChooseSignMethod
        show={!!showModal.chooseSignMethod}
        setShow={(state) => changeModalProperty('chooseSignMethod', state)}
        header={'Chọn phương thức thêm chứng thư số'}
        content={'Vui lòng chọn phương thức thêm chứng thư số'}
        handleChooseUSBToken={() => {
          changeModalProperty('chooseSignMethod', false)
          handlePressedAddDigitalCertificate()
        }}
        handleChooseHSM={() => {
          changeModalProperty('chooseSignMethod', false)
          changeModalProperty('connectConfig', true)
        }}
        handleChooseManually={() => {
          changeModalProperty('signatureInfo', true)
          changeModalProperty('chooseSignMethod', false)
        }}
      />

      <ModalWarning
        show={!!showModal.confirm}
        setShow={(state) => changeModalProperty('confirm', state)}
        header="Xác nhận"
        content="Vui lòng đảm bảo thông tin cập nhật là chính xác trước khi lưu. Việc nhập sai thông tin từ hệ thống cũ (bao gồm cả mã CQT và số thứ tự bắt đầu) có thể dẫn đến sai sót trong việc phát hành hóa đơn."
        handleConfirm={() => {
          changeRegistrationProperty('locationName', '')

          screenAction == 'sua'
            ? handleUpdateRegistration()
            : handlecreateRegistrationAccountingDocuments()
        }}
      />
      <ModalWarning
        show={!!showModal.warning.visible}
        setShow={(state) =>
          changeModalProperty('warning', {
            visible: state,
            message: '',
          })
        }
        header="Thông báo"
        content={showModal.warning.message}
      />
    </div>
  )
}

export default CreateRegistration
